"use strict";

const mutationObserver = new (window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver)(
    (mutations, mutationObserver) => {
        mutations.forEach(function (mutation) {
            Array.from(mutation.addedNodes.values())
                .filter(node => node.nodeType === 1)
                .forEach(node => mutationObserver.execute(node));
        });
    });

mutationObserver.listeners = [];

mutationObserver.add = function (selector, callback) {
    this.listeners.push([selector, callback]);
};

mutationObserver.execute = function (node) {
    this.listeners.forEach(([selector, callback]) => {
        const elements = Array.from(node.querySelectorAll(selector));
        if (node.matches(selector)) {
            elements.push(node);
        }
        elements.forEach(e => callback.call(e, e))
    });
}

//mutationObserver.observe(document.body, {childList: true, subtree: true, characterData: false, attributes: false});
mutationObserver.observe(document, {childList: true, subtree: true, characterData: false, attributes: false});

window.$ice = function (selector, callback) {
    mutationObserver.add(selector, callback);
    document.querySelectorAll(selector).forEach(e => callback.call(e, e))
};
